import { NeoModel, Validation, ValueObject } from '@singularsystems/neo-core';

@NeoModel
export default class TermsAndConditionsStatusLookupCriteria extends ValueObject {

    public alwaysFetchTermsAndConditions: boolean = false;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Terms And Conditions Status Lookup Criteria";
    }
}